import React from "react";

import { StyledSVG } from "../StyledIcon";

export const ShoppingCartIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M3.5 5.5H15.4612C16.1849 5.5 16.669 6.24485 16.3751 6.90614L13.8843 12.5102C13.6168 13.1121 13.02 13.5 12.3613 13.5H6.75081C6.03634 13.5 5.40135 13.0446 5.1722 12.3679L2.32073 3.94717C2.12901 3.381 1.59775 3 1 3V3"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse cx="6.5" cy="15.5" rx="1.5" ry="1.5" fill={iconColor} />
      <ellipse cx="12.5" cy="15.5" rx="1.5" ry="1.5" fill={iconColor} />
    </StyledSVG>
  );
};
